/*
 * @Date: 2023-10-08 14:28:36
 * @Description: 中国省级货物贸易主题库，只包含 数据部分
 */
import Layout from "@/layout";
import { getProvinceMeta } from "../utils/utils";
import { baseRef } from "../utils/baseRef";
export default [
  {
    path: "/chplt",
    redirect: "/chplt/home",
  },
  {
    path: "/chplt/data",
    component: Layout,
    redirect: "/chplt/data/goods",
    name: "data",
    meta: {
      title: "数据",
      icon: "iconfont iconshuju1",
      theme: "chplt",
    },
    children: [
      {
        path: "goods",
        name: "goodsTrade",
        redirect: "/chplt/data/goods/quanguo",
        component: () => import("@/views/data/goods/common-theme"),
        meta: { title: "中国货物贸易" },
        children: [
          {
            path: "quanguo",
            redirect: "/chplt/data/goods/quanguo/quanguoMonth",
            component: () => import("@/views/data/goods/common-theme"),
            name: "quanguo",
            meta: {
              title: "全国",
              icon: "iconshuju2 2-1",
              showOnlyOneChild: true,
            },
            children: [
              {
                path: "quanguoMonth",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "quanguoMonth",
                meta: getProvinceMeta(
                  {
                    title: "全国月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "0",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "huabei",
            redirect: "/chplt/data/goods/huabei/beijing",
            component: () => import("@/views/data/goods/common-theme"),
            name: "huabei",
            meta: { title: "华北", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "beijing",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "beijing",
                meta: getProvinceMeta(
                  {
                    title: "北京月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "11",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "tianjin",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "tianjin",
                meta: getProvinceMeta(
                  {
                    title: "天津月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "12",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "hebei",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "hebei",
                meta: getProvinceMeta(
                  {
                    title: "河北月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "13",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "shanxi",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "shanxi",
                meta: getProvinceMeta(
                  {
                    title: "山西月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "14",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "neimenggu",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "neimenggu",
                meta: getProvinceMeta(
                  {
                    title: "内蒙古月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "15",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "huadong",
            redirect: "/chplt/data/goods/huadong/shanghai",
            component: () => import("@/views/data/goods/common-theme"),
            name: "huadong",
            meta: { title: "华东", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "shanghai",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "shanghai",
                meta: getProvinceMeta(
                  {
                    title: "上海月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "31",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "jiangsu",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "jiangsu",
                meta: getProvinceMeta(
                  {
                    title: "江苏月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "32",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "zhejiang",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "zhejiang",
                meta: getProvinceMeta(
                  {
                    title: "浙江月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "33",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "anhui",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "anhui",
                meta: getProvinceMeta(
                  {
                    title: "安徽月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "34",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "fujian",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "fujian",
                meta: getProvinceMeta(
                  {
                    title: "福建月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "35",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "jiangxi",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "jiangxi",
                meta: getProvinceMeta(
                  {
                    title: "江西月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "36",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "shandong",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "shandong",
                meta: getProvinceMeta(
                  {
                    title: "山东月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "37",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "huanan",
            redirect: "/chplt/data/goods/huanan/guangdong",
            component: () => import("@/views/data/goods/common-theme"),
            name: "huanan",
            meta: { title: "华南", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "guangdong",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "guangdong",
                meta: getProvinceMeta(
                  {
                    title: "广东月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "44",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "guangxi",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "guangxi",
                meta: getProvinceMeta(
                  {
                    title: "广西月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "45",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "hainan",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "hainan",
                meta: getProvinceMeta(
                  {
                    title: "海南月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "46",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "huazhong",
            redirect: "/chplt/data/goods/huazhong/henan",
            component: () => import("@/views/data/goods/common-theme"),
            name: "huazhong",
            meta: { title: "华中", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "henan",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "henan",
                meta: getProvinceMeta(
                  {
                    title: "河南月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "41",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "hubei",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "hubei",
                meta: getProvinceMeta(
                  {
                    title: "湖北月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "42",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "hunan",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "hunan",
                meta: getProvinceMeta(
                  {
                    title: "湖南月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "43",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "dongbei",
            redirect: "/chplt/data/goods/dongbei/liaoning",
            component: () => import("@/views/data/goods/common-theme"),
            name: "dongbei",
            meta: { title: "东北", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "liaoning",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "liaoning",
                meta: getProvinceMeta(
                  {
                    title: "辽宁月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "21",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "jilin",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "jilin",
                meta: getProvinceMeta(
                  {
                    title: "吉林月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "22",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "heilongjiang",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "heilongjiang",
                meta: getProvinceMeta(
                  {
                    title: "黑龙江月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "23",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "xinan",
            redirect: "/chplt/data/goods/xinan/chongqing",
            component: () => import("@/views/data/goods/common-theme"),
            name: "xinan",
            meta: { title: "西南", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "chongqing",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "chongqing",
                meta: getProvinceMeta(
                  {
                    title: "重庆月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "50",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "sichuan",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "sichuan",
                meta: getProvinceMeta(
                  {
                    title: "四川月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "51",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "guizhou",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "guizhou",
                meta: getProvinceMeta(
                  {
                    title: "贵州月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "52",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "yunnan",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "yunnan",
                meta: getProvinceMeta(
                  {
                    title: "云南月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "53",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "xizang",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "xizang",
                meta: getProvinceMeta(
                  {
                    title: "西藏月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "54",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
          {
            path: "xibei",
            redirect: "/chplt/data/goods/xibei/shantxi",
            component: () => import("@/views/data/goods/common-theme"),
            name: "xibei",
            meta: { title: "西北", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "shantxi",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "shantxi",
                meta: getProvinceMeta(
                  {
                    title: "陕西月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "61",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "gansu",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "gansu",
                meta: getProvinceMeta(
                  {
                    title: "甘肃月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "62",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "qinghai",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "qinghai",
                meta: getProvinceMeta(
                  {
                    title: "青海月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "63",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "ningxia",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "ningxia",
                meta: getProvinceMeta(
                  {
                    title: "宁夏月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "64",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
              {
                path: "xinjiang",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "xinjiang",
                meta: getProvinceMeta(
                  {
                    title: "新疆月度",
                    productId: [2112],
                    timeApi: "getYears",
                    timeParam: "C",
                  },
                  {
                    flowDefault: "3",
                    coinDefault: "2",
                    goodsDefualt: "100000",
                    mainbodyDefault: "65",
                    partnerDefault: "0",
                    wayDefault: "0",
                  }
                ),
              },
            ],
          },
        ],
      },
      {
        path: "HK",
        newpath: "/data/goods/asia/HK/detail",
        component: () => import("@/views/data/goods/common-theme"),
        name: "HK",
        meta: { title: "中国香港货物贸易" },
        children: [
          {
            path: "monthly",
            component: () =>
              import("@/views/data/goods/common-theme/CommonTheme"),
            name: "monthly",
            meta: baseRef["中国香港月度"],
          },
          {
            path: "annual",
            component: () =>
              import("@/views/data/goods/common-theme/CommonTheme"),
            name: "annual",
            meta: baseRef["中国香港年度"],
          },
          {
            path: "detail",
            hidden: true,
            component: () => import("@/views/data/goods/asia/chinaHK/detail"),
            name: "detail",
            meta: { title: "数据介绍" },
          },
        ],
      },

      {
        path: "Macao",
        newpath: "/data/goods/asia/Macao/detail",
        component: () => import("@/views/data/goods/common-theme"),
        name: "Macao",
        meta: { title: "中国澳门货物贸易" },
        children: [
          {
            path: "monthly",
            component: () =>
              import("@/views/data/goods/common-theme/CommonTheme"),
            name: "monthly",
            meta: baseRef["中国澳门月度"],
          },
          {
            path: "annual",
            component: () =>
              import("@/views/data/goods/common-theme/CommonTheme"),
            name: "annual",
            meta: baseRef["中国澳门年度"],
          },
          {
            path: "detail",
            hidden: true,
            component: () =>
              import("@/views/data/goods/asia/chinaMacao/detail"),
            name: "detail",
            meta: { title: "数据介绍" },
          },
        ],
      },
    ],
  },
  {
    path: "/chplt/monitor",
    component: Layout,
    // newpath: "/chplt/monitor/detail",
    redirect: "/chplt/monitor/tradeOverview/tradeTotal",
    name: "data",
    meta: {
      title: "监测",
      icon: "iconfont iconjiance",
      theme: "chplt",
    },
    children: [
      {
        path: "tradeOverview",
        redirect: "/chplt/monitor/tradeOverview/tradeTotal",
        component: () => import("@/views/data/goods/common-theme"),
        name: "tradeOverview",
        meta: {
          title: "贸易概况",
          icon: "iconshuju2 2-1",
          showOnlyOneChild: true,
        },
        children: [
          {
            path: "tradeTotal",
            name: "tradeTotal",
            component: () => import("@/views/monitorTemplate/index"),
            meta: { title: "贸易总量" },
          },
          {
            path: "commodityComposition",
            name: "commodityComposition",
            component: () =>
              import("@/views/monitorTemplate/commodityComposition"),
            meta: { title: "商品构成" },
          },
        ],
      },
      {
        path: "tradeStructure",
        redirect: "/chplt/monitor/tradeStructure/goodsStructure",
        component: () => import("@/views/data/goods/common-theme"),
        name: "tradeStructure",
        meta: {
          title: "贸易结构",
          icon: "iconshuju2 2-1",
          showOnlyOneChild: true,
        },
        children: [
          {
            path: "goodsStructure",
            name: "goodsStructure",
            component: () => import("@/views/monitorTemplate/goodsStructure"),
            meta: { title: "商品结构" },
          },
          {
            path: "countryStructure",
            name: "countryStructure",
            component: () => import("@/views/monitorTemplate/countryStructure"),
            meta: { title: "国别结构" },
          },
        ],
      },
      {
        path: "tradeConnection",
        redirect: "/chplt/monitor/tradeConnection/tradeComplementarity",
        component: () => import("@/views/data/goods/common-theme"),
        name: "tradeConnection",
        meta: {
          title: "贸易联系",
          icon: "iconshuju2 2-1",
          showOnlyOneChild: true,
        },
        children: [
          {
            path: "tradeComplementarity",
            name: "tradeComplementarity",
            component: () =>
              import("@/views/monitorTemplate/tradeComplementarity"),
            meta: { title: "贸易互补" },
          },
          {
            path: "tradeCompetition",
            name: "tradeCompetition",
            component: () => import("@/views/monitorTemplate/tradeCompetition"),
            meta: { title: "贸易竞争" },
          },
          {
            path: "tradeIndex",
            name: "tradeIndex",
            component: () => import("@/views/monitorTemplate/tradeIndex"),
            meta: { title: "贸易指数" },
          },
        ],
      },
      {
        path: "flow",
        redirect: "/chplt/monitor/flow/tradeFlow",
        component: () => import("@/views/data/goods/common-theme"),
        name: "flow",
        meta: {
          title: "贸易流向",
          icon: "iconshuju2 2-1",
          showOnlyOneChild: false,
        },
        children: [
          {
            path: "tradeFlow",
            name: "tradeFlow",
            component: () => import("@/views/monitorTemplate/tradeFlow"),
            meta: { title: "贸易流向" },
          },
        ],
      },
      {
        path: "relations",
        redirect: "/chplt/monitor/relations/tradeRelations",
        component: () => import("@/views/data/goods/common-theme"),
        name: "relations",
        meta: {
          title: "贸易关系",
          icon: "iconshuju2 2-1",
          showOnlyOneChild: false,
        },
        children: [
          {
            path: "tradeRelations",
            name: "tradeRelations",
            component: () => import("@/views/monitorTemplate/tradeRelations"),
            meta: { title: "贸易关系" },
          },
        ],
      },
      // {
      //   path: "detail",
      //   hidden: true,
      //   component: () => import("@/views/monitorTemplate/detail"),
      //   name: "detail",
      //   meta: { title: "数据库介绍" },
      // },
    ],
  },
  {
    path: "/chplt/report",
    component: Layout,
    // newpath: "/chplt/report/detail",
    redirect: "/chplt/report/chpltReport",
    name: "report",
    meta: {
      title: "报告",
      icon: "iconfont iconbaogao",
      theme: "chplt",
      showOnlyOneChild: true,
    },
    children: [
      {
        path: "chpltReport",
        name: "chpltReport",
        component: () => import("@/views/reportTemplate/reportList"),
        meta: { title: "中国货物贸易概况" },
      },
      {
        path: "chpltReportDetails",
        name: "chpltReportDetails",
        hidden: true,
        component: () => import("@/views/reportTemplate/reportDetails"),
        meta: { title: "货物贸易概况详情" },
      },
      {
        path: "reportDetailsChina",
        name: "reportDetailsChina",
        hidden: true,
        component: () => import("@/views/reportTemplate/reportDetailsChina"),
        meta: { title: "货物贸易概况详情" },
      },
      // {
      //   path: "detail",
      //   hidden: true,
      //   component: () => import("@/views/reportTemplate/detail"),
      //   name: "detail",
      //   meta: { title: "数据库介绍" },
      // },
    ],
  },
];
